import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  paddingBottom24: {
    paddingBottom: 24,
  },
  sectionHeaderStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 24,
    marginTop: 24,
    marginBottom: 8,
  },
  flex1: {
    flex: 1,
  },
  marginHorizontal8: {
    marginHorizontal: 8,
  },
  emptyListContainer: {
    marginTop: 100,
    marginBottom: 50,
    alignItems: 'center',
  },
});
